import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';
import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';
import { clearTextFromTags } from '../../helpers/titreHelper';

const Message = ({
  className,
  message,
  titrTag,
  setDelay,
  messagesWrapper,
  currentMessageRef,
  authorFontSize,
  msgFontSize,
  user,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const isCurrent = currentMessageRef?.message?.id === message?.id;

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper,
    isCurrent
  );

  const errorHandler = (e, nameChannel) => {
    e.target.src = iconsSources[nameChannel];
  };

  const idChannels = ['telegram', 'max'];
  const clrsBorder = {
    max: 'linear-gradient(0deg, #9541dd, rgb(151, 64, 221, 0))',
    telegram: 'linear-gradient(0deg, #039be5, rgb(151, 64, 221, 0))',
  };

  const nameChannel = idChannels.includes(message?.channel)
    ? message?.channel
    : 'telegram';

  return (
    <div className={cn(styles.wrapper, className)}>
      {message && (
        <>
          <div className={styles.top}>
            <div className={styles.avatar}>
              <img
                src={
                  (message?.image !== '1' && message?.image) ||
                  iconsSources[nameChannel]
                }
                alt={message?.author}
                onError={(e) => errorHandler(e, nameChannel)}
              />
            </div>
            <div className={cn(styles.name)}>
              <div style={{ fontSize: `${authorFontSize}rem` }}>
                {message?.senderNumberMask}
              </div>
            </div>
          </div>
          <div className={styles.contentWrapper}>
            <div
              className={styles.content}
              style={{ '--gradient': clrsBorder[nameChannel] }}
            >
              <div
                className={styles.textWrapper}
                ref={contentContainerRef}
                style={{ maxHeight: `${11 * 1.24 * msgFontSize}rem` }}
              >
                {message?.content && (
                  <div
                    className={styles.text}
                    ref={contentRef}
                    style={{ fontSize: `${msgFontSize}rem` }}
                  >
                    {clearTextFromTags(message.content)}
                  </div>
                )}
              </div>

              {/* {message?.attachments &&
                message?.attachments[0] &&
                message.attachments[0].type === 'image' && (
                  <div className={styles.contentImg}>
                    <img
                      src={message?.attachments[0].url}
                      alt={message?.author || hideNumber(message?.senderNumber)}
                    />
                  </div>
                )} */}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
